import { gql } from "@apollo/client"

const GET_ORGANIZATIONS = gql`
  query getMyOrganizations($staff_id: ID!) {
    myOrganizations: getMyOrganizationsByUid(staff_id: $staff_id) {
      value: organization_id
      label: organization_name
      organization_id
      organization_name
      organization_status
      organization_type
      current_staff_users
      current_participants
      current_programs
      current_locations
    }
  }
`
const GET_ENTERPRISE = gql`
  query Enterprises($staff_id: ID!, $enterprise_id: ID!) {
    enterprises: statsEnterprisesByUid(
      staff_id: $staff_id
      enterprise_id: $enterprise_id
    ) {
      enterprise_id
      enterprise_name
    }
  }
`

const GET_ORGANIZATIONS_IDSTAMP = gql`
  query Organizations($staff_id: ID!, $organization_id: ID!) {
    organizations: statsOrganizationsByUid(
      staff_id: $staff_id
      organization_id: $organization_id
    ) {
      organization_id
      organization_name
      organization_status
      current_staff_users
      current_participants
      current_programs
      current_locations
      organization_id_stamp
    }
  }
`

export { GET_ORGANIZATIONS, GET_ENTERPRISE, GET_ORGANIZATIONS_IDSTAMP }
